/**
 * File history.
 *
 * Handles history blocks.
 */
(function ($) {
    'use strict';

    $(document).ready(function () {
        sliderInit();
        $(window).on('resize', function(){
            sliderInit();
        });

        $(document).on('click', '.history-list .history-list__years-list .history-list__year', function(){
            let windowWidth = $(window).outerWidth();
            let dataYear = $(this).data('get-year');
            let currentTopPos = $(this).parent().position().top;
            $(this).parent().addClass('active').siblings().removeClass('active');
            $(this).parents('.history-list__row').find('.history-list__year-detail-item[data-year-related="'+ dataYear +'"]').addClass('active').siblings().removeClass('active');
            if( windowWidth > 767 ) {
                $(this).parents('.history-list__years-wrap').find('.history-list__years-barinnner').height(currentTopPos + 8);
            }
        });
        
    });

    // Height adjust in selected bar
    function sliderInit() {
        let windowWidth = $(window).outerWidth();

        $('.history-list').each(function(){
            if( windowWidth > 767 ) {
                $(this).find('.history-list__years-list.slick-initialized').slick('unslick');
            } else {
                let dataYearCount = $(this).find('.history-list__years-list').data('year-count') || 7;
                $(this).find('.history-list__years-list:not(.slick-initialized)').slick({
                    centerMode: 7 < dataYearCount ? true : false,
                    dots: false,
                    arrows: false,
                    infinite: true,
                    touchMove: false,
                    speed: 300,
                    slidesToShow: 7,
                    slidesToScroll: 1,
                    focusOnSelect: true,
                    responsive: [
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 6,
                                centerMode: 6 < dataYearCount ? true : false,
                            }
                        },
                        {
                            breakpoint: 500,
                            settings: {
                                slidesToShow: 5,
                                centerMode: 5 < dataYearCount ? true : false,
                            }
                        },
                        {
                            breakpoint: 400,
                            settings: {
                                slidesToShow: 4,
                                centerMode: 4 < dataYearCount ? true : false,
                            }
                        },
                        {
                            breakpoint: 350,
                            settings: {
                                slidesToShow: 3,
                                centerMode: 3 < dataYearCount ? true : false,
                            }
                        },
                    ]
                });
            }
        });
    }

})(jQuery);